/**
 * Typed wrapper around PostHog's useFeatureFlag hook.
 *
 * Provides a clean import path for consumers and centralizes the
 * PostHog feature flag API surface for the application.
 * @module
 */
import { useFeatureFlag } from "posthog-react-native";

/**
 * Evaluates a PostHog remote feature flag by key.
 *
 * Returns the flag value: `true`/`false` for boolean flags,
 * a string variant for multivariate flags, or `undefined` while
 * flags are still loading from the PostHog server.
 * @param flagKey - The feature flag key as defined in the PostHog dashboard
 * @returns The flag value, or undefined while loading
 * @example
 * ```typescript
 * const isEnabled = usePostHogFeatureFlag("new-dashboard") === true;
 * const variant = usePostHogFeatureFlag("checkout-experiment");
 * ```
 */
const usePostHogFeatureFlag = (flagKey: string): boolean | string | undefined =>
  useFeatureFlag(flagKey);

export default usePostHogFeatureFlag;
